import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import { AppContext } from "../../App";
import { MobileContext } from "../Mobile";

const useStyles = makeStyles(theme => ({
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  content: {
    minHeight: "calc(100vh - 56px)",
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      minHeight: "calc(100vh - 48px)"
    },
    [theme.breakpoints.up("sm")]: {
      minHeight: "calc(100vh - 64px)"
    }
  },
  widgetContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
}));

const Inicio = () => {
  const classes = useStyles();
  const { store } = useContext(AppContext);
  const { onOpenSideBar } = useContext(MobileContext);

  return (
    <>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            className={classes.menuButton}
            edge="start"
            color="inherit"
            onClick={onOpenSideBar}
          >
            <MenuIcon />
          </IconButton>

          <Typography className={classes.title} variant="h6">
            {store.name}
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <div className={classes.content}></div>
      </Container>
    </>
  );
};

export default Inicio;
